export const getGoalDetailFormStyles = () => ({
  formBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '& Label': {
      fontWeight: 'normal',
    },
  },

  labelHelp: {
    display: 'flex',
    gap: '5px',

    '& button': {
      color: 'unset',
    },
  },
  accordionHeader: {
    color: '#115EA3',
    width: '145px',
    '& button': {
      padding: 0,
    },
  },
  accordionPanel: {
    margion: 0,
  },
  rowContainer: {
    display: 'flex',
    gap: '12px',
  },
});
